export const getCanvasTextWidth = (text, context, textStyle) => {
    if (!context) {
        return 0;
    }

    const { fontSize, fontWeight, fontFamily } = textStyle;

    context.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
    return context.measureText(text).width;
};

export const wrapText = (context, text, maxWidth, textStyle) => {
    let result = '';
    let testLine = '';

    text.split(' ').forEach((word) => {
        const testWidth = getCanvasTextWidth(`${testLine}${word}`, context, textStyle);

        if (testWidth > maxWidth && testLine) {
            result += `${testLine.trimEnd()}\n`;
            testLine = '';
        }

        testLine += `${word} `;
    });

    result += testLine;

    return result.trim();
};

export const getAdoptedTextAndStyles = (
    text,
    width,
    canvasElement,
    textStyle,
    minFontSize = 16
) => {
    const { fontSize } = textStyle;

    let size = fontSize;

    const context = canvasElement?.getContext('2d');

    while (
        getCanvasTextWidth(text, context, { ...textStyle, fontSize: size }) > width &&
        size > minFontSize
    ) {
        size--;
    }

    const adoptedTextStyle = {
        ...textStyle,
        fontSize: size,
    };

    return {
        text: wrapText(context, text, width, adoptedTextStyle),
        textStyle: adoptedTextStyle,
    };
};

export default (title, subTitle, containerWidth, context, styles, marginWidth = 170) => {
    const { text, textStyle } = getAdoptedTextAndStyles(
        title,
        containerWidth - marginWidth,
        context,
        styles.textStyle
    );

    const { text: subtext, textStyle: subtextStyle } = getAdoptedTextAndStyles(
        subTitle,
        containerWidth - marginWidth - 60,
        context,
        styles.subtextStyle
    );

    return {
        ...styles,
        text,
        textStyle,
        subtext,
        subtextStyle,
    };
};
